import React from 'react';
import { HeroSection } from './components/HeroSection';
import { DiagnosticoSection } from './components/DiagnosticoSection';
import { SistemaAceSection } from './components/SistemaAceSection';
import { CtaFinalSection } from './components/CtaFinalSection';
export function App() {
  return <main className="min-h-screen w-full bg-carbon font-body text-white selection:bg-gold/30 selection:text-gold-light" data-id="element-0">
      <HeroSection data-id="element-1" />
      <DiagnosticoSection data-id="element-2" />
      <SistemaAceSection data-id="element-3" />
      <CtaFinalSection data-id="element-4" />
    </main>;
}